exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nb-dica{position:relative;background:#267da5;padding:8px;color:#fff;font-weight:400;line-height:18px;border-radius:3px;height:35px;z-index:20;margin:-3px 0 0 15px;user-select:none;animation:tooltip_animation 2s linear infinite}@keyframes tooltip_animation{0%,20%,40%,60%,80%,to{transform:translateX(0)}50%{transform:translateX(-5px)}}.nb-dica:before{content:\" \";width:0;height:0;position:absolute;left:-7px;top:8px;border-color:transparent #267da5;border-style:solid;border-width:8px 8px 8px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c1887d0","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms/regraimp-add-form.vue
// module id = 1587
// module chunks = 0